import { render, staticRenderFns } from "./RecruitingDetails.vue?vue&type=template&id=086f58f4&scoped=true&"
import script from "./RecruitingDetails.vue?vue&type=script&lang=js&"
export * from "./RecruitingDetails.vue?vue&type=script&lang=js&"
import style0 from "./RecruitingDetails.vue?vue&type=style&index=0&id=086f58f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086f58f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VSelect,VTab,VTabItem,VTabs,VTabsItems})
